"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paginteListApiResponseSchema = void 0;
const zod_1 = require("zod");
const paginteListApiResponseSchema = (dataSchema) => zod_1.z.object({
    page: zod_1.z.number().default(1),
    per_page: zod_1.z.number().default(-1),
    page_count: zod_1.z.number().default(1),
    data: zod_1.z.array(dataSchema),
});
exports.paginteListApiResponseSchema = paginteListApiResponseSchema;
